import config from 'config/config'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { initialize } from 'redux-form'
import { Icon, Image, Table } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      initialize,
    },
    dispatch
  )
}

class StandardDownload extends React.Component {
  assetThumbnail(medium) {
    if (medium && medium.content_type.match(/^image/))
      return <Image src={config.api_url + medium.thumb} />
    if (medium && medium.content_type === 'application/pdf')
      return <Icon name="file pdf outline" />
    return false
  }

  render() {
    const { medium, action, title, initialize } = this.props
    return (
      <tr className={!medium && 'disabled'}>
        <Table.Cell
          width={1}
          content={this.assetThumbnail(medium)}
          className="keep"
        />
        <Table.Cell width={10} className="ellipsis">
          <strong className="ellipsis">{title}</strong>
          <br />
          <span className="german tag ellipsis">
            {medium && medium.title_de}
          </span>
          <span className="french tag ellipsis">
            {medium && medium.title_fr}
          </span>
        </Table.Cell>
        <Table.Cell width={1} className="keep ellipsis">
          <Icon
            link
            {...config.icons.edit}
            onClick={(event) => {
              event.preventDefault()
              initialize('mediaBrowserEdit', {
                id: medium.id,
                title_de: medium.title_de,
                title_fr: medium.title_fr,
              })
            }}
          />
        </Table.Cell>
        <Table.Cell width={1} className="keep">
          <Icon {...config.icons.delete} onClick={action} link />
        </Table.Cell>
      </tr>
    )
  }
}

StandardDownload = connect(mapStateToProps, mapDispatchToProps)(
  StandardDownload
)
export default StandardDownload



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/StandardDownload.jsx